import {useState} from 'react';
import {Outlet} from 'react-router-dom';

import {DashboardLayout} from '@shared/layouts';
import {loadDataFromLocalStorage, saveDataToLocalStorage} from '@shared/utils';
import {Header} from './Header';
import {SideBar} from './SideBar';

const localStorageKey = 'sidebarCollapsed';

interface SidebarSettings {
  isCollapsed: boolean;
}

export const DashboardPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    () =>
      loadDataFromLocalStorage<SidebarSettings>(localStorageKey)?.isCollapsed ??
      false,
  );

  const handleCollapsedChange = (isCollapsed: boolean) => {
    setIsSidebarCollapsed(isCollapsed);
    saveDataToLocalStorage({isCollapsed}, localStorageKey);
  };

  return (
    <DashboardLayout
      isSidebarCollapsed={isSidebarCollapsed}
      header={<Header />}
      sidebar={
        <SideBar
          isCollapsed={isSidebarCollapsed}
          onCollapsedChange={handleCollapsedChange}
        />
      }
      mainContent={<Outlet />}
    />
  );
};
